import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../../../../parts/modal-new";
import VideoUpload from "../components/VideoUpload";

const id = "modal-link-program";
const form = "link-program";

const LinkProgram = ({ workflow, explanationAdded }) => {
  const { t } = useTranslation(["coaching-portal", "common"]);
  const [addVideo, setAddVideo] = useState(false);
  useEffect(() => {
    if (explanationAdded) {
      setAddVideo(false);
    }
  }, [explanationAdded]);
  return (
    <form
      action={
        addVideo
          ? "/actions/getting-started/video"
          : "/actions/getting-started/link-program"
      }
      method="POST"
      encType="multipart/form-data"
      data-noreset
      id={form}
    >
      <input type="hidden" name="option" value="program" />
      <input type="hidden" name="workflow" value={workflow._id} />

      <Modal
        name={id}
        key={id}
        title={t("linkProgram.title")}
        className="getting-started-video narrow"
        toClear={["explanationAdded"]}
      >
        <div className="body">
          {addVideo ? (
            <VideoUpload
              form={form}
              video={workflow.options.program?.video}
              explanationVideo
              goBack={() => setAddVideo(false)}
            />
          ) : (
            <div className="form-row-item">
              <p className="p2 mb-4">
                {t("linkProgram.descriptionPrefix")}{" "}
                <a
                  href="/coaching-portal/services?modal[type]=information&service=program-quiz"
                  target="_blank" rel="noopener"
                >
                  {t("linkProgram.descriptionHere")}
                </a>{" "}
                {t("linkProgram.descriptionSuffix")}
              </p>
              <label className="sub-label" htmlFor="url">
                {t("linkProgram.urlLabel")}
              </label>
              <input
                className="url-input"
                type="text"
                name="url"
                placeholder={t("linkProgram.urlPlaceholder")}
                defaultValue={workflow.options.program?.url}
                form={form}
              />
            </div>
          )}
        </div>

        <footer className="foot">
          {!addVideo && !explanationAdded && (
            <button
              onClick={() => setAddVideo(true)}
              type="button"
              data-button-type="outline"
              className="mr-auto"
            >
              <span>{t("customWorkflows.addExplanationVideo")}</span>
            </button>
          )}
          <button data-button-type="primary" type="submit">
            {addVideo ? t("customWorkflows.addVideoButton") : t("common:save")}
          </button>
        </footer>
      </Modal>
    </form>
  );
};

export default LinkProgram;
